import React from "react";
import { bindAll, isEqual, isEmpty } from "lodash";
import queryString from "query-string";
import scrollToComponent from "react-scroll-to-component";
import ProductTable from "../Components/ProductTable";
import Questionnaire from "../Components/Questionnaire";
import Enroll from "../Components/Enroll";
import Download from "../Components/Download";
import * as Data from "../Components/products";
import Fade from "../Utils/Fade";
import Contact from "../Components/Contact/Contact";
import {
  formsFilteredProducts,
  filterProducts,
} from "../Components/products";

export default class App extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedProduct: {},
      widgetType: window.WIDGET_TYPE || 0,
      translationData: null,
    };
    bindAll(this, ["handleProductClicked"]);
  }

  componentDidMount() {
    let params = queryString.parse(window.location.search);
    let product = params.product;
    if (product !== undefined) {
      let selectedProduct = Data.products.filter(function (item) {
        return item.name === product;
      })[0];
      if (!isEmpty(selectedProduct)) {
        this.setState({ selectedProduct });
      }
    }
    let translationData = null;
    this.props.dataApi.fetchTranslationData(
      function (response) {
        translationData = response;
        this.setState({ translationData });
      }.bind(this)
    );
  }

  componentDidUpdate() {
    scrollToComponent(this.questionnaireArea, {
      offset: -100,
      align: "top",
      duration: 1000,
    });
  }

  handleProductClicked(product) {
    let { selectedProduct } = this.state;
    if (isEqual(selectedProduct, product)) {
      selectedProduct = {};
    } else {
      selectedProduct = product;
    }
    this.setState({ selectedProduct });
  }

  render() {
    const { selectedProduct, widgetType, translationData } = this.state;
    return (
      <div>
        {!isEmpty(translationData)
          ? (() => {
              switch (widgetType) {
                default:
                case 0:
                  return (
                    <div>
                      <div
                        id="products-area"
                        className={
                          !isEmpty(selectedProduct) ? "triangle" : null
                        }
                      >
                        <div className="container">
                          <div className="section-heading">
                            <h2
                              className="title text-center wow fadeInDown"
                              data-wow-delay=".3s"
                            >
                              {translationData.eligibleWidgetTitle}
                            </h2>
                            <p
                              className="text-center wow fadeInDown"
                              data-wow-delay=".5s"
                            >
                              {translationData.eligibleWidgetComment}
                            </p>
                          </div>
                          <ProductTable
                            products={filterProducts}
                            selected={selectedProduct}
                            clickHandler={this.handleProductClicked}
                            widgetType="eligible"
                          />
                        </div>
                      </div>
                      {!isEmpty(selectedProduct) ? (
                        <div
                          id="questionnaire-area"
                          ref={(div) => {
                            this.questionnaireArea = div;
                          }}
                        >
                          <div className="container">
                            <Fade duration={1}>
                              <Questionnaire
                                product={selectedProduct}
                                dataApi={this.props.dataApi}
                                translationData={translationData}
                              />
                            </Fade>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  );
                case 1:
                  return (
                    <div>
                      <div
                        id="products-area"
                        className={
                          !isEmpty(selectedProduct) ? "triangle" : null
                        }
                      >
                        <div className="container">
                          <ProductTable
                            // products={Data.products}
                            products={filterProducts}
                            selected={selectedProduct}
                            clickHandler={this.handleProductClicked}
                            widgetType="enroll"
                          />
                        </div>
                      </div>
                      {!isEmpty(selectedProduct) ? (
                        <div
                          id="enroll-area"
                          ref={(div) => {
                            this.questionnaireArea = div;
                          }}
                        >
                          <div className="container">
                            <Fade duration={1}>
                              <Enroll
                                product={selectedProduct}
                                dataApi={this.props.dataApi}
                                translationData={translationData}
                              />
                            </Fade>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  );
                case 2:
                  return (
                    <div>
                      <div
                        id="products-area"
                        className={
                          !isEmpty(selectedProduct) ? "triangle" : null
                        }
                      >
                        <div className="container">
                          <div className="section-heading">
                            <p
                              className="downloading-heading text-center wow fadeInDown"
                              data-wow-delay=".5s"
                            >
                              {translationData.downloadTop}
                            </p>
                          </div>
                          <ProductTable
                            products={formsFilteredProducts}
                            selected={selectedProduct}
                            clickHandler={this.handleProductClicked}
                            widgetType="download"
                          />
                        </div>
                      </div>
                      {!isEmpty(selectedProduct) ? (
                        <div
                          id="download-area"
                          ref={(div) => {
                            this.questionnaireArea = div;
                          }}
                        >
                          <div className="container">
                            <Fade duration={1}>
                              <Download
                                product={selectedProduct}
                                dataApi={this.props.dataApi}
                                translationData={translationData}
                              />
                            </Fade>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  );
                case 3:
                  return (
                    <div>
                      <div
                        id="products-area"
                        className={
                          !isEmpty(selectedProduct) ? "triangle" : null
                        }
                      >
                        <div className="container">
                          <ProductTable
                            // products={Data.products}
                            products={filterProducts}
                            selected={selectedProduct}
                            clickHandler={this.handleProductClicked}
                            widgetType="contact"
                          />
                        </div>
                      </div>
                      {!isEmpty(selectedProduct) ? (
                        <div
                          id="contact-area"
                          ref={(div) => {
                            this.questionnaireArea = div;
                          }}
                        >
                          <div className="container">
                            <Fade duration={1}>
                              <Contact
                                product={selectedProduct}
                                dataApi={this.props.dataApi}
                                translationData={translationData}
                              />
                            </Fade>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  );
              }
            })()
          : null}
      </div>
    );
  }
}
